import { MailOutlineSharp, PhoneAndroidSharp } from '@mui/icons-material'
import { Box, styled, Typography } from '@mui/material'

const MainContactBar = styled(Box)(({theme}) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  }

}));

const C = styled(Box)(({theme}) => ({

}));

function QuickContacts() {
  return (
    <MainContactBar>
      <Typography fontWeight={600} sx={{ fontSize: { xs: '0.8rem', mdlg: '0.9rem', bp1000: '1.1rem'}, mr: 1 }} >Contact for Customized Reports :</Typography>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }} >
        <PhoneAndroidSharp sx={{ fontSize: { xs: '0.8rem', mdlg: '0.9rem', bp1000: '1.1rem'} }} />
        <Typography sx={{ fontSize: { xs: '0.8rem', mdlg: '0.9rem', bp1000: '1.1rem'}}} >+91 9637373615</Typography>
        <Typography sx={{ fontSize: '1.1rem', mx: 1 }} >|</Typography>
        <MailOutlineSharp sx={{ fontSize: { xs: '0.8rem', mdlg: '0.9rem', bp1000: '1.1rem'} }} />
        <Typography sx={{ fontSize: { xs: '0.8rem', mdlg: '0.9rem', bp1000: '1.1rem'} }} >data.pi@zohomail.in</Typography>
      </Box>
    </MainContactBar>
  )
}

export default QuickContacts